import type { CSSProperties } from "react"

export const VITAL_COLORS: Record<string, string> = {
  hp: "#D96C6C",
  mana: "#6C8BD9",
  energy: "#D9B86C"
}

export const VITAL_FALLBACK_COLOR = "#a0a0a0"

export const vitalColor = (code: string): string =>
  Object.hasOwn(VITAL_COLORS, code) ? VITAL_COLORS[code] : VITAL_FALLBACK_COLOR

export const vitalBarStyle = (code: string): CSSProperties =>
  ({ "--vital-color": vitalColor(code) }) as CSSProperties
